export default __webpack_public_path__ + "static/media/noe-display-bold-italic.f6cb7636.eot";